import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { RequirementField } from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';
import { UntypedFormGroup } from '@angular/forms';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'ba-multiselect',
    templateUrl: 'multiselect-attribute.component.html',
    styleUrls: ['multiselect-attribute.component.scss'],
})

export class MultiselectAttributeComponent implements OnInit, OnDestroy {

    @Input() field: RequirementField;
    @Input() form: UntypedFormGroup;
    @Input() disabled: boolean;

    dropdownList: Object[];
    selectedItems: Object[];

    destroyed$ = new Subject<void>();

    ngOnInit () {
        if (!this.field || !this.field.options) { return; }

        this.dropdownList = this.field.options;

        // Initialize value
        this.selectedItems = this.getSelectedValues(this.field.options, this.control.value);

        // Watch for changes on the value
        this.control.valueChanges.pipe(
            takeUntil(this.destroyed$)
        ).subscribe(newVal => {
            this.selectedItems = this.getSelectedValues(this.field.options, newVal);
        });
    }

    onChange() {
        const value = this.formatSelectedValues(this.selectedItems);
        this.control.markAsDirty();
        this.control.setValue(value, { emitEvent: false, emitModelToViewChange: false });
    }

    getSelectedValues(options, value) {
        const selected = value ? value.split(',') : [];
        return options.filter(option => selected.includes(option.value));
    }

    formatSelectedValues(selected) {
        if (selected.length === 0) {
            return null;
        }
        return selected.map(option => option.value).join(',');
    }

    get control() {
        return this.form.controls[this.field.alias];
    }

    ngOnDestroy() {
        this.destroyed$.next();
    }
}
